export default [
  {
    path: '/netdisk',
    name: 'Netdisk',
    component: () => import(/* webpackChunkName: "instance" */ "@/views/netdisk"),
    meta: {title: '网盘管理'}
  }
]
